var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    customer_news_card:
      this.newsType == 'PERCE_NEWS' || this.newsType == 'GREAT_TIP',
  }},[_c('div',{staticClass:"card_date"},[_vm._v(" "+_vm._s(_vm.article.createdAt)+" ")]),_c('div',{staticClass:"card",on:{"click":function($event){return _vm.newsDetail(_vm.article)}}},[_c('div',{staticClass:"thumb"},[_c('div',{staticClass:"inner"},[_c('img',{attrs:{"src":_vm.article.bgImgPath,"alt":""}})])]),_c('div',{staticClass:"card_con"},[_c('div',{staticClass:"line_clamp"},[_vm._v(_vm._s(_vm.article.title))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }